import { routerSelectors } from 'src/app/core/router/router.selectors'

import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { RolePermissions } from './role-permissions'
import * as fromRolePermission from './role-permissions.reducer'

const state = createFeatureSelector<fromRolePermission.RolePermissionsState>(
  fromRolePermission.FEATURE_NAME
)

const adapter = fromRolePermission.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)

const selectIsLoading = createSelector(state, (state) => state.isLoading)

const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<RolePermissions>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (
    entities: RolePermissions[],
    filter?: { field: string; value: string | number }
  ) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectIdRouteParam = createSelector(
  routerSelectors.selectRouteParams,
  (params) => {
    return params && params.rolePermissionsId
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)

export const rolePermissionsSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectIdRouteParam,
  selectCount
}
